import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";
import state from "./state";
import * as jobPostActions from "./jobPostActions";

export default {
  namespaced: true,
  state,
  actions: {
    ...actions,
    ...jobPostActions,
  },
  mutations: {
    ...mutations,
  },
  getters: {
    ...getters,
  },
};
